import React from 'react';
import { connectionsDetailsLabels } from '../../../../../../constants/connections-labels.constants';
import TextWithCopyBtn from '../_text-with-copy-btn/text-with-copy-btn';
import { BaseConnectionDetailsPopoverContentProps } from './types';


type InPersonConnectionDetailsPopoverContentProps = Omit<BaseConnectionDetailsPopoverContentProps, 'onLinkClick'>;

export const InPersonConnectionDetailsPopoverContent = (props: InPersonConnectionDetailsPopoverContentProps): JSX.Element => {
    const { connection, onCopyBtnClick } = props;
    const { type, name } = connection;

    const labels = connectionsDetailsLabels();

    return (
        <div className='connection-list__field'>{type} {labels.CONNECTION_NAME()}:<br />
            <TextWithCopyBtn message={name} handleCopyClick={onCopyBtnClick} />
        </div>
    );
};
